import { useMemo, type ReactNode } from 'react';
import { VendorStatus } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { Dot } from '@sib/ui/icons';
import { getVendorStatusColor } from './vendor-status-styles';

const VENDOR_STATUS_ORDER = Object.values(VendorStatus);

interface VendorStatusOption<T> {
  value: T;
  label: string;
  color: string;
  Icon: ReactNode;
}

export const useVendorStatusOptions = <T extends string>() => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      VENDOR_STATUS_ORDER.map(value => {
        const color = getVendorStatusColor(value);

        return {
          value,
          label: t(`enums.vendorStatus.${value}`),
          color,
          Icon: <Dot style={{ color }} />,
        };
      }),
    [t]
  ) as VendorStatusOption<T>[];
};
